'use client';

import React__default, { useState } from 'react';
import { CompanyJob } from './CompanyItem.css.js';
import PreviewJob from '../PreviewJob/index.js';
import { ELanguage } from '../Utils/constants.js';
import { decrypt, isMobile } from '../Utils/helpers.js';
import { Anchor } from '../Typography/components/Variant.js';
import { colors } from '../Colors/index.js';
import ApplyJobs from '../ApplyJobs/index.js';
import '../Images/AddIcon/index.js';
import '../Images/AddOutlinedIcon/index.js';
import '../Images/Trash/index.js';
import '../Images/Pencil/index.js';
import '../_virtual/_tslib.js';
import '../Images/ArrowRoundedLeft/index.js';
import '../Images/ArrowRoundedRight/index.js';
import '../Images/AwardsIcon/index.js';
import '../Images/BonusIcon/index.js';
import '../Images/CanteenIcon/index.js';
import '../Images/CheckTagIcon/index.js';
import '../Images/CommercialIcon/index.js';
import '../Images/CompanySizeIcon/index.js';
import '../Images/ContactIcon/index.js';
import '../Images/CopyIcon/index.js';
import '../Images/DefaultAvatar/index.js';
import '../Images/DangerIcon/index.js';
import '../Images/ExternalLinkIcon/index.js';
import '../Images/FacebookIcon/index.js';
import '../Images/ForwardIcon/index.js';
import '../Images/HealthcarePlanIcon/index.js';
import '../Images/HeartIcon/index.js';
import '../Images/HeartOutlineIcon/index.js';
import '../Images/HideIcon/index.js';
import '../Images/KindergartenIcon/index.js';
import '../Images/LaptopIcon/index.js';
import '../Images/LibraryIcon/index.js';
import '../Images/LinkIcon/index.js';
import '../Images/LinkedInIcon/index.js';
import '../Images/LoadingCircleIcon/index.js';
import '../Images/MarkerIcon/index.js';
import '../Images/MobileIcon/index.js';
import '../Images/PaidLeaveIcon/index.js';
import '../Images/SearchIcon/index.js';
import '../Images/ShareIcon/index.js';
import '../Images/ReportIcon/index.js';
import '../Images/StatsIcon/index.js';
import '../Images/TeamActivitiesIcon/index.js';
import '../Images/ThreeDotIcon/index.js';
import '../Images/TrainingIcon/index.js';
import '../Images/TransportationIcon/index.js';
import '../Images/TrashIcon/index.js';
import '../Images/TravelOpportunitiesIcon/index.js';
import '../Images/VerticalMoreIcon/index.js';
import '../Images/VoucherIcon/index.js';
import '../Images/WowCVIcon/index.js';
import '../Images/WorkingLocationIcon/index.js';
import '../Images/ZaloIcon/index.js';
import '../Images/FacebookLogoIcon/index.js';
import '../Images/GoogleLogoIcon/index.js';
import '../Images/DragReorderIcon/index.js';
import '../Images/CheckIcon/index.js';
import '../Images/CircleChecked/index.js';
import '../Images/SalaryIcon/index.js';
import '../Images/BriefcaseIcon/index.js';
import '../Images/GraduationCapIcon/index.js';
import '../Images/EnvelopeIcon/index.js';
import '../Images/AddFilledIcon/index.js';
import '../Images/HomeIcon/index.js';
import '../Images/PhoneIcon/index.js';
import '../Images/AttachIcon/index.js';
import '../Images/FilterIcon/index.js';
import '../icons/WarnIcon.js';
import '../icons/AccountSettingsIcon.js';
import '../icons/DashboardIcon.js';
import '../icons/JobAlertsIcon.js';
import '../icons/MyCompaniesIcon.js';
import '../icons/MyJobsIcon.js';
import '../icons/MyProfileIcon.js';
import '../icons/ProfileSettingsIcon.js';
import '../icons/LanguageIcon.js';
import '../icons/BenefitGroupIcons/ActivityIcon.js';
import '../icons/BenefitGroupIcons/AwardsIcon.js';
import '../icons/BenefitGroupIcons/BonusIcon.js';
import '../icons/BenefitGroupIcons/CanteenIcon.js';
import '../icons/BenefitGroupIcons/HealthcareIcon.js';
import '../icons/BenefitGroupIcons/KindergartenIcon.js';
import '../icons/BenefitGroupIcons/LaptopIcon.js';
import '../icons/BenefitGroupIcons/LibraryIcon.js';
import '../icons/BenefitGroupIcons/MoreIcon.js';
import '../icons/BenefitGroupIcons/PaidLeaveIcon.js';
import '../icons/BenefitGroupIcons/PhoneIcon.js';
import '../icons/BenefitGroupIcons/TrainingIcon.js';
import '../icons/BenefitGroupIcons/TransportationIcon.js';
import '../icons/BenefitGroupIcons/TravelIcon.js';
import '../icons/BenefitGroupIcons/VoucherIcon.js';
import '../icons/BenefitGroupIcons/Physics.js';
import '../icons/BenefitGroupIcons/WorkingHourIcon.js';
import '../icons/BenefitGroupIcons/WorkingDayIcon.js';
import '../icons/BenefitGroupIcons/WorkingTypeIcon.js';
import '../icons/AccountCenterGroupIcons/ChartVertical.js';
import '../icons/AccountCenterGroupIcons/Language.js';
import '../icons/AccountCenterGroupIcons/EmptyHotCategory.js';
import '../icons/AccountCenterGroupIcons/Lawyer.js';
import '../icons/InfoOverviewGroupIcons/CompanySize.js';
import '../icons/InfoOverviewGroupIcons/Location.js';
import '../icons/InfoOverviewGroupIcons/Education.js';
import '../icons/InfoOverviewGroupIcons/PhoneNumber.js';
import '../icons/InfoOverviewGroupIcons/CalendarIOS16Glyph.js';
import '../icons/InfoOverviewGroupIcons/Admin.js';
import '../icons/InfoOverviewGroupIcons/HeadHunter.js';
import '../icons/InfoOverviewGroupIcons/Address.js';
import '../icons/InfoOverviewGroupIcons/Salary.js';
import '../icons/InfoOverviewGroupIcons/Gender.js';
import '../icons/InfoOverviewGroupIcons/Translator.js';
import '../icons/InfoOverviewGroupIcons/Birthday.js';
import '../icons/InfoOverviewGroupIcons/LocationIOS16Glyph.js';
import '../icons/InfoOverviewGroupIcons/CreditIcon.js';
import '../icons/MiscGroupIcons/Link.js';
import '../icons/MiscGroupIcons/History.js';
import '../icons/MiscGroupIcons/Favorite.js';
import '../icons/MiscGroupIcons/UnFavorite.js';
import '../icons/MiscGroupIcons/ProductDocuments.js';
import '../icons/MiscGroupIcons/Star.js';
import '../icons/SocialMediaGroupIcons/Facebook.js';
import '../icons/SocialMediaGroupIcons/Linkedin.js';
import '../icons/SocialMediaGroupIcons/Twitter.js';
import '../icons/SocialMediaGroupIcons/Zalo.js';
import '../icons/SocialMediaGroupIcons/FacebooksColorFull.js';
import '../icons/SocialMediaGroupIcons/LinkedinColorFull.js';
import '../icons/SocialMediaGroupIcons/TwitterColorFull.js';
import '../icons/SocialMediaGroupIcons/ZaloColorFull.js';
import '../icons/SocialMediaGroupIcons/Share.js';
import '../icons/NavigationGroupIcons/Vertical.js';
import '../icons/NavigationGroupIcons/More.js';
import '../icons/NavigationGroupIcons/Close.js';
import '../icons/NavigationGroupIcons/Expand.js';
import '../icons/NavigationGroupIcons/Collapse.js';
import '../icons/NavigationGroupIcons/Next.js';
import '../icons/NavigationGroupIcons/Back.js';
import '../icons/NavigationGroupIcons/ExternalLink.js';
import '../icons/NavigationGroupIcons/RightArrow.js';
import '../icons/AlertGroupIcons/SuccessIcon.js';
import '../icons/AlertGroupIcons/CareerPath.js';
import '../icons/AlertGroupIcons/Hot.js';
import '../icons/AlertGroupIcons/Urgent.js';
import '../icons/FormActionGroupIcons/Exchange.js';
import '../icons/FormActionGroupIcons/AddTag.js';
import '../icons/RewardsTypeGroupIcons/Hospital.js';
import MailAddIcon from '../Images/MailAddIcon/index.js';
import '../Images/DoubleTickIcon/index.js';
import '../Images/BellIcon/index.js';
import '../Images/AiIcon/index.js';
import '../Images/MiniAiIcon/index.js';
import '../icons/OrderManagementIcon.js';
import '../Images/TwinkleLinearGradientIcon/index.js';
import { JobInvitationIcon } from '../JobCard/JobCard.css.js';

var JobItem = function (props) {
    var _a, _b;
    var job = props.job, user = props.user, _c = props.langCode, langCode = _c === void 0 ? ELanguage.VI : _c, baseMsUrl = props.baseMsUrl, baseUrl = props.baseUrl, decryptToken = props.decryptToken;
    var _d = useState(false), isShowPopUpApplyJob = _d[0], setIsShowPopUpApplyJob = _d[1];
    var togglePopApplyJob = function () {
        setIsShowPopUpApplyJob(!isShowPopUpApplyJob);
    };
    var salary = job.salary && job.salary !== '' ? job.salary : job.prettySalary;
    var userToken = decryptToken ? decrypt((user === null || user === void 0 ? void 0 : user.accessToken) || '') : (user === null || user === void 0 ? void 0 : user.accessToken) || '';
    var PreviewJobWrapper = function (_a) {
        var _b, _c, _d, _e;
        var children = _a.children;
        return isMobile() ? (React__default.createElement(React__default.Fragment, null, children)) : (React__default.createElement(PreviewJob, { content: {
                jobId: job === null || job === void 0 ? void 0 : job.jobId,
                logo: job === null || job === void 0 ? void 0 : job.companyLogo,
                title: job === null || job === void 0 ? void 0 : job.jobTitle,
                salary: String(salary),
                jobLevel: langCode === ELanguage.VI ? job === null || job === void 0 ? void 0 : job.jobLevelVI : job === null || job === void 0 ? void 0 : job.jobLevel,
                address: job === null || job === void 0 ? void 0 : job.address,
                jobDescription: job === null || job === void 0 ? void 0 : job.jobDescription,
                jobRequirements: job === null || job === void 0 ? void 0 : job.jobRequirement,
                link: job.jobUrl,
                isSaved: (_b = job === null || job === void 0 ? void 0 : job.isSaved) !== null && _b !== void 0 ? _b : false,
                isApplied: (_c = job === null || job === void 0 ? void 0 : job.isApplied) !== null && _c !== void 0 ? _c : false,
                isBlackList: (_d = job === null || job === void 0 ? void 0 : job.isBlackList) !== null && _d !== void 0 ? _d : false,
                redirectTo: '',
                jobInvitation: (_e = job === null || job === void 0 ? void 0 : job.jobInvitation) !== null && _e !== void 0 ? _e : { jobInvitationId: 0, status: 0 }
            }, api: {
                accessToken: userToken,
                baseUrl: baseMsUrl
            }, onApplyClick: function () { return setIsShowPopUpApplyJob(true); }, langCode: langCode, isLogin: !!(user === null || user === void 0 ? void 0 : user.accessToken) }, children));
    };
    return (React__default.createElement(CompanyJob, null,
        React__default.createElement(PreviewJobWrapper, null,
            React__default.createElement("p", { className: 'job-title' },
                job.jobInvitation && ((_a = job.jobInvitation) === null || _a === void 0 ? void 0 : _a.jobInvitationId) > 0 && ((_b = job.jobInvitation) === null || _b === void 0 ? void 0 : _b.status) === 0 ? (React__default.createElement(JobInvitationIcon, { style: { float: 'left' } },
                    React__default.createElement(MailAddIcon, null))) : null,
                React__default.createElement(Anchor, { name: 'title', size: 'small', color: colors.grey[40], href: job.jobUrl +
                        '?utm_source_navi=CompanyRecommendation&utm_medium_navi=Dashboard&utm_campaign_navi=OpenningJob', target: '_blank' }, job.jobTitle))),
        React__default.createElement(ApplyJobs, { accessToken: userToken, isOpen: isShowPopUpApplyJob, langCode: langCode, user: user, jobInfo: job, baseMsUrl: baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '', baseUrl: baseUrl !== null && baseUrl !== void 0 ? baseUrl : '', initData: props.initData, onClose: togglePopApplyJob }),
        React__default.createElement("p", null,
            React__default.createElement("span", { className: 'job-salary' }, salary),
            ' ',
            React__default.createElement("span", { className: 'job-location' },
                "| ",
                langCode === ELanguage.VI ? job.locationsVI : job.locations))));
};

export { JobItem as default };
//# sourceMappingURL=JobItem.js.map
